// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"VolumeDiscountBanner_bannerContainer__Mwpuv"};